import { gql } from 'graphql-request';

import { TaskFileAttachmentIds, TaskUUID } from '../tasksTypes';

export interface SubmitFileAttachmentsAsSourceFilesToTaskResponse {
  uuid: TaskUUID;
  fileAttachmentIds: TaskFileAttachmentIds;
}

export const SUBMIT_FILE_ATTACHMENTS_AS_SOURCE_FILES_TO_TASK_QUERY = gql`
  mutation SubmitFileAttachmentsAsSourceFilesToTask(
    $uuid: ID!
    $fileAttachmentIds: [ID!]!
    $moveToDeepArchive: Boolean
  ) {
    submitFileAttachmentsAsSourceFilesToTask(
      input: {
        uuid: $uuid
        fileAttachmentIds: $fileAttachmentIds
        moveToDeepArchive: $moveToDeepArchive
      }
    ) {
      recordUuid
      recordNanoId
      status
      record {
        uuid
        nanoId
      }
      errors {
        fullMessages
      }
    }
  }
`;
